import React from 'react';
import MarketplaceHeader from './components/MarketplaceHeader';
import FilterBar from './components/FilterBar';
import IntegrationGrid from './components/IntegrationGrid';
import MarketplaceFooter from './components/MarketplaceFooter';

const IntegrationsMarketplace = () => {
  return (
    <div className="min-h-screen bg-[#0F0F11]">
      <MarketplaceHeader />
      <FilterBar />
      <IntegrationGrid />
      <MarketplaceFooter />
    </div>
  );
};

export default IntegrationsMarketplace;